import React from 'react'
import ReactToPrint from "react-to-print";
import companylogo from "../../assets/company.png"

const PaymentsPrint = (props) => {
    const componentRef = React.createRef();
    return (
        <>
            <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200">
                <ReactToPrint
                    trigger={() => (
                        <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                            Print / Download
                        </button>
                    )}
                    content={() => componentRef.current}
                />
                <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-[1050px] relative">
                    <div>
                        <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                            <div>

                                <img  src={companylogo} alt="logo" />
                            </div>
                        </div>
                        <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                            {props.clientpay === true ? (
                                <>
                                    <p>Client Recieving Voucher</p>
                                </>
                            ) : (
                                <>
                                    <p>Payment Details</p>
                                </>
                            )}
                        </article>

                        <div className=" flex justify-between my-5">
                            <article className=" flex items-start justify-start">
                                {props.vendor ? (
                                    <>
                                        <ul>
                                            <li className="p-1 ">
                                                <span className="font-bold">Vendor's name:</span> {props.vendor}
                                            </li>
                                            <li className="p-1 ">
                                                <span className="font-bold">Vendor's ID:</span> {props.vendorId}
                                            </li>
                                            <li className="p-1 ">
                                                <span className="font-bold">Status:</span> {props.status}
                                            </li>
                                        </ul>
                                    </>
                                ) : (
                                    <>
                                        <ul>
                                            <li className="p-1 ">
                                                <span className="font-bold">Customer's name:</span> {props.client}
                                            </li>
                                            <li className="p-1 ">
                                                <span className="font-bold">Customer's ID:</span> {props.clientId}
                                            </li>
                                            <li className="p-1 ">
                                                <span className="font-bold">Status:</span> {props.status}
                                            </li>
                                        </ul>
                                    </>
                                )}

                            </article>
                            <article className=" flex items-end justify-end">
                                <ul>
                                    <li className="p-1 ">
                                        <>
                                            <span className="font-bold">Payment ID:</span> {props.paymentNumber}
                                        </>
                                    </li>
                                    <li className="p-1 ">
                                        <>
                                            <span className="font-bold">Payment Type:</span> {props.type}
                                        </>
                                    </li>
                                    {props.chequenumber && (
                                        <li className="p-1 ">
                                            <>
                                                <span className="font-bold">Cheque number:</span> {props.chequenumber}
                                            </>
                                        </li>
                                    )}
                                    {props.refnumber && (
                                        <li className="p-1 ">
                                            <>
                                                <span className="font-bold">Reference number:</span> {props.refnumber}
                                            </>
                                        </li>
                                    )}
                                    <li className="p-1 ">
                                        <span className="font-bold">Payment date:</span> {props.paymentDate}
                                    </li>
                                    <li className="p-1 ">
                                        <span className="font-bold">Payment Amount:</span> {props.paymentAmount}
                                    </li>
                                </ul>
                            </article>
                        </div>

                    </div>
                    {props.notes &&
                        <section className="mt-10 mb-5">
                            <h3 span className="font-bold">Additional notes:</h3>
                            <p className="lg:w-1/2 text-justify">« {props.notes} »</p>
                        </section>
                    }
                    <footer className=" absolute bottom-0 left-0 right-0 footer border-t-2 border-gray-300 pb-5">
                        <div className=" w-full flex justify-evenly pt-4 pb-14 px-5 border-b border-gray-300 mb-2 text-base">
                            <p>Prepared By</p>
                            <p>Approved By</p>
                            <p>Salesman</p>
                            <p className=" ">Reciever's Name & Signature </p>
                            <p>Store Keeper</p>

                        </div>
                        <ul className="flex flex-wrap items-center gap-2 justify-center">
                            <li>
                                <span className="font-bold">Email:</span> {"arcoglassqatar@gmail.com"}
                            </li>
                            <li>
                                <span className="font-bold">Tel:</span> {"4460 5198"}<span className="ml-1 font-bold">-Fax:</span> {"4451 7172"}
                            </li>
                            <li>
                                <span className="font-bold">P.O Box:</span> {"40992, Doha-Qatar "}
                            </li>
                        </ul>
                    </footer>

                </div>
            </div>
        </>
    )
}

export default PaymentsPrint